import Drawable from '../entities/Drawable.js';
import { spriteStore } from '../images.js';
import PixelText from './PixelText.js';

export default class StatIncreaseBox extends Drawable {
    constructor({
        sprites = { statIncreaseBox: spriteStore.store.statIncreaseBox },
        position = spriteStore.store.statIncreaseBox.position,
        pokemon,
        visible,
    }) {
        super();
        this.visible = visible;
        this.sprites = sprites;
        this.position = position;
        this.width = this.sprites.statIncreaseBox.image.width;
        this.height = this.sprites.statIncreaseBox.image.height;
        this.pokemon = pokemon;
        this.showTotal = false;

        this.hpLabel = new PixelText({
            text: 'HP',
            color: 'black',
            textAlign: 'left',
            position: { x: this.position.x + 8, y: this.position.y + 16 - 7 },
        });
        this.attackLabel = new PixelText({
            text: 'ATTACK',
            color: 'black',
            textAlign: 'left',
            position: { x: this.position.x + 8, y: this.position.y + 32 - 7 },
        });
        this.defenseLabel = new PixelText({
            text: 'DEFENSE',
            color: 'black',
            textAlign: 'left',
            position: { x: this.position.x + 8, y: this.position.y + 48 - 7 },
        });
        this.specialAttackLabel = new PixelText({
            text: 'SP ATK',
            color: 'black',
            textAlign: 'left',
            position: { x: this.position.x + 8, y: this.position.y + 64 - 7 },
        });
        this.specialDefenseLabel = new PixelText({
            text: 'SP DEF',
            color: 'black',
            textAlign: 'left',
            position: { x: this.position.x + 8, y: this.position.y + 80 - 7 },
        });
        this.speedLabel = new PixelText({
            text: 'SPEED',
            color: 'black',
            textAlign: 'left',
            position: { x: this.position.x + 8, y: this.position.y + 96 - 7 },
        });
        const statsIncrease = this.pokemon.statIncreaseHistory[this.pokemon.level];

        const hpStatString = statsIncrease.increase ? `+ ${statsIncrease.increase.hp}` : '';
        this.hpStat = new PixelText({
            text: hpStatString,
            color: 'black',
            textAlign: 'right',
            position: {
                x: this.position.x + this.width - 8,
                y: this.position.y + 16 - 7,
            },
        });

        const attackStatString = statsIncrease.increase ? `+ ${statsIncrease.increase.attack}` : '';
        this.attackStat = new PixelText({
            text: attackStatString,
            color: 'black',
            textAlign: 'right',
            position: {
                x: this.position.x + this.width - 8,
                y: this.position.y + 32 - 7,
            },
        });

        const defenseStatString = statsIncrease.increase ? `+ ${statsIncrease.increase.defense}` : '';
        this.defenseStat = new PixelText({
            text: defenseStatString,
            color: 'black',
            textAlign: 'right',
            position: {
                x: this.position.x + this.width - 8,
                y: this.position.y + 48 - 7,
            },
        });

        const specialAttackStatString = statsIncrease.increase
            ? `+ ${statsIncrease.increase.specialAttack}`
            : '';
        this.specialAttackStat = new PixelText({
            text: specialAttackStatString,
            color: 'black',
            textAlign: 'right',
            position: {
                x: this.position.x + this.width - 8,
                y: this.position.y + 64 - 7,
            },
        });

        const specialDefenseStatString = statsIncrease.increase
            ? `+ ${statsIncrease.increase.specialDefense}`
            : '';
        this.specialDefenseStat = new PixelText({
            text: specialDefenseStatString,
            color: 'black',
            textAlign: 'right',
            position: {
                x: this.position.x + this.width - 8,
                y: this.position.y + 80 - 7,
            },
        });

        const speedStatString = statsIncrease.increase ? `+ ${statsIncrease.increase.speed}` : '';
        this.speedStat = new PixelText({
            text: speedStatString,
            color: 'black',
            textAlign: 'right',
            position: {
                x: this.position.x + this.width - 8,
                y: this.position.y + 96 - 7,
            },
        });
    }

    draw() {
        if (!this.visible) {
            return;
        }
        this.sprites.statIncreaseBox.draw();
        this.hpLabel.draw();
        this.attackLabel.draw();
        this.defenseLabel.draw();
        this.specialAttackLabel.draw();
        this.specialDefenseLabel.draw();
        this.speedLabel.draw();
        this.hpStat.draw();
        this.attackStat.draw();
        this.defenseStat.draw();
        this.specialAttackStat.draw();
        this.specialDefenseStat.draw();
        this.speedStat.draw();
    }
}
